<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_user.user_detail')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-member-content" fluid v-if="user">
        <v-tabs show-arrows
                v-model="tabIndex">
          <v-tab>{{ $t('register.basic_info') }}</v-tab>
          <v-tab-item>
            <v-container fluid>
              <v-form ref="userForm">
                <v-row>
                  <v-col cols="6">
                    <v-input hide-details="auto">
                      <v-container fluid class="flex-column d-flex align-center">
                        <legend class="v-label theme--light">{{ $t('admin_user.jwt') }}</legend>
                        <qrcode :value="jwt" :options="{ width: 200 }" class="account-info-membership-qrcode"></qrcode>
                      </v-container>
                    </v-input>
                  </v-col>
                  <v-col cols="6">
                    <v-input hide-details="auto">
                      <v-container fluid class="flex-column">
                        <legend class="v-label theme--light">{{ $t('admin_acc_gym_checkin.account_pic') }}</legend>
                        <PhotoPreviewInput v-model="accountPic"
                                           use-camera
                                           file-name="item-type-icon"></PhotoPreviewInput>
                        <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG</small>
                      </v-container>
                    </v-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  :label="$t('admin_user.serial_no')"
                                  v-model="user.id"></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.email')"
                                  v-model="user.account.email"></v-text-field>
                  </v-col>
                </v-row>
                <!--                <v-row>-->
                <!--                  <v-col>-->
                <!--                    <v-text-field readonly-->
                <!--                                  :label="$t('my_account.email_verified_at')"-->
                <!--                                  :value="userEmailVerifiedAtLabel"></v-text-field>-->
                <!--                  </v-col>-->
                <!--                </v-row>-->
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.mobile')"
                                  v-model="user.mobile"></v-text-field>
                  </v-col>
                  <v-col>
                    <v-select outlined
                              :label="$t('register.salutation')"
                              :items="salutationOptions"
                              v-model="user.salutation"
                              :rules="requiredRules"></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  readonly
                                  :label="$t('register.surname_en')"
                                  v-model="user.surname_en"
                                  :rules="requiredRules"></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field outlined
                                  readonly
                                  :label="$t('register.given_name_en')"
                                  v-model="user.given_name_en"
                                  :rules="requiredRules"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  readonly
                                  :label="$t('register.surname_zh')"
                                  v-model="user.surname_zh"></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field outlined
                                  readonly
                                  :label="$t('register.given_name_zh')"
                                  v-model="user.given_name_zh"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="user.company">
                  <v-col>
                    <v-select outlined
                              readonly
                              :label="$t('register.company')"
                              :items="companyOptions"
                              v-model="user.company.id"
                              :rules="requiredRules"></v-select>
                  </v-col>
                </v-row>
                <!--                <v-row>-->
                <!--                  <v-col>-->
                <!--                    <v-text-field readonly-->
                <!--                                  :label="$t('my_account.membership_valid_until')"-->
                <!--                                  :value="userMembershipValidUntilLabel"></v-text-field>-->
                <!--                  </v-col>-->
                <!--                </v-row>-->
                <!--                <v-row>-->
                <!--                  <v-col>-->
                <!--                    <v-text-field outlined-->
                <!--                                  :label="$t('my_account.octopus_id')"-->
                <!--                                  :value="user.octopus_id"></v-text-field>-->
                <!--                  </v-col>-->
                <!--                </v-row>-->
                <v-row>
                  <v-col>
                    <v-menu ref="menu"
                            v-model="showAccMembershipValidUntilDatePicker"
                            :close-on-content-click="false"
                            :return-value="user.acc_membership_valid_until"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field outlined
                                      append-icon="fas fa-calendar-day"
                                      :label="$t('my_account.acc_membership_valid_until')"
                                      :value="accMembershipValidUntilLabel"
                                      readonly
                                      v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="user.acc_membership_valid_until"
                                     no-title
                                     scrollable>
                        <v-spacer></v-spacer>
                        <!--                        <v-btn text color="primary" @click="clearAccMembershipValidUntilDate">Clear</v-btn>-->
                        <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-menu ref="accMembershipSuspendUntilMenu"
                            v-model="showAccMembershipSuspendUntilDatePicker"
                            :close-on-content-click="false"
                            :return-value="user.acc_suspend_until"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field outlined
                                      append-icon="fas fa-calendar-day"
                                      :label="$t('admin_user.acc_suspend_until')"
                                      :value="accMembershipSuspendUntilLabel"
                                      readonly
                                      v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="user.acc_suspend_until"
                                     no-title
                                     scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="clearAccMembershipSuspendUntilDate">Clear</v-btn>
                        <v-btn text color="primary" @click="$refs.accMembershipSuspendUntilMenu.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  readonly
                                  :label="$t('admin_user.welcome_gift_redeemed')"
                                  :value="userWelcomeGiftRedeemedLabel"></v-text-field>
                  </v-col>
                  <v-col cols="3" v-if="!user.welcome_gift_redeemed">
                    <v-btn block
                           large
                           color="primary"
                           @click="redeemWelcomeGift">REDEEM
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox :label="$t('admin_user.is_trial_user')"
                                v-model="user.is_trial_user"></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox :label="$t('my_account.receive_promotional_email')"
                                readonly
                                v-model="user.receive_promotional_email"></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  :label="$t('my_account.point_balance')"
                                  :value="user.point_balance"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-textarea outlined
                                auto-grow
                                rows="1"
                                :label="$t('admin_user.remarks')"
                                v-model="user.remarks"></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-tab-item>

          <v-tab>{{ $t('my_account.id_verified_at') }}</v-tab>
          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-text-field readonly
                                outlined
                                :label="$t('admin_sasv.status')"
                                :value="sasvStatus"></v-text-field>
                </v-col>
              </v-row>
              <v-form v-if="user.sasv">
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.octopus_no')"
                                  :value="sasv.octopus_no"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.name')"
                                  :value="sasv.name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="sasv.company">
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.company')"
                                  :value="sasv.company.name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.id_type')"
                                  :value="$t(`id_type.${sasv.id_type}`)"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="sasv && sasv.id_type !== 'VIP'">
                  <v-col>
                    <v-expansion-panels accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header>{{ $t('admin_sasv.id') }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col>
                              <v-input>
                                <v-container fluid class="flex-column pa-0">
                                  <legend class="v-label theme--light">{{ $t('admin_sasv.octopus_front') }}</legend>
                                  <v-img contain
                                         :src="getURL(sasv.octopus_front)"
                                         max-height="300px"></v-img>
                                </v-container>
                              </v-input>
                            </v-col>
                            <v-col>
                              <v-input>
                                <v-container fluid class="flex-column pa-0">
                                  <legend class="v-label theme--light">{{ $t('admin_sasv.octopus_back') }}</legend>
                                  <v-img contain
                                         :src="getURL(sasv.octopus_back)"
                                         max-height="300px"></v-img>
                                </v-container>
                              </v-input>
                            </v-col>
                          </v-row>
                          <v-row v-if="sasv.id_type === 'PERSONAL_OCTOPUS_AND_STAFF_CARD'">
                            <v-col>
                              <v-input>
                                <v-container fluid class="flex-column pa-0">
                                  <legend class="v-label theme--light">{{ $t('admin_sasv.staff_card_front') }}</legend>
                                  <v-img contain
                                         :src="getURL(sasv.staff_card_front)"
                                         max-height="300px"></v-img>
                                </v-container>
                              </v-input>
                            </v-col>
                            <v-col>
                              <v-input>
                                <v-container fluid class="flex-column pa-0">
                                  <legend class="v-label theme--light">{{ $t('admin_sasv.staff_card_back') }}</legend>
                                  <v-img contain
                                         :src="getURL(sasv.staff_card_back)"
                                         max-height="300px"></v-img>
                                </v-container>
                              </v-input>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.validated_at')"
                                  v-if="sasv.validated_at"
                                  :value="$parseDate(sasv.validated_at)"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="sasv.rejected_at">
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.rejected_at')"
                                  :value="$parseDate(sasv.rejected_at)"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="sasv.rejected_at">
                  <v-col>
                    <v-text-field readonly
                                  outlined
                                  :label="$t('admin_sasv.reject_reason')"
                                  :value="sasv.reject_reason"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-tab-item>

          <v-tab :disabled="!$hasPermission('hkiarace.manage_event')">{{ $t('admin_user.enrollment_history') }}</v-tab>
          <v-tab-item>
            <EnrollmentList :user-id="accountId"
                            v-if="tabIndex === 2"
                            hide-select></EnrollmentList>
          </v-tab-item>

          <v-tab :disabled="!$hasPermission('hkiarace.manage_event')">{{ $t('admin_user.attendance_history') }}</v-tab>
          <v-tab-item>
            <ParticipantList :user-id="accountId"
                             v-if="tabIndex === 3"
                             hide-select></ParticipantList>
          </v-tab-item>

          <v-tab :disabled="!$hasPermission('acc.list_booking')">{{ $t('admin_user.booking_history') }}</v-tab>
          <v-tab-item>
            <AdminBookingList full-height
                              hide-search
                              :user-id="accountId"
                              :refresh-trigger.sync="bookingRefreshTrigger"
                              @edit="onBookingEdit"
                              v-if="tabIndex === 4"></AdminBookingList>

            <EditBookingModal :shown="editBookingModalShown"
                              :booking-id="editingBookingId"
                              @cancel="onEditBookingModalFinish"
                              @finish="onEditBookingModalFinish"></EditBookingModal>
          </v-tab-item>

          <v-tab :disabled="!$hasPermission('payment.list_record')">{{ $t('admin_user.payment_history') }}</v-tab>
          <v-tab-item>
            <AdminPaymentRecordList full-height
                                    :user-id="accountId"
                                    v-if="tabIndex === 5"></AdminPaymentRecordList>
          </v-tab-item>

          <v-tab>{{ $t('admin_user.coupon') }}</v-tab>
          <v-tab-item>
            <AdminCouponList full-height
                             :user-id="accountId"
                             v-if="tabIndex === 6"></AdminCouponList>
          </v-tab-item>

          <v-tab>{{ $t('my_account.points') }}</v-tab>
          <v-tab-item>
            <AdminPointTransactionList full-height
                                       :user-id="accountId"
                                       v-if="tabIndex === 7"></AdminPointTransactionList>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.userForm.validate() && saveUser()"
               v-if="tabIndex === 0">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import {computed, ref, watch} from '@vue/composition-api';
import BGModal from "@/components/BGModal";
import {DateTime} from "luxon";
import EnrollmentList from "@/components/event/enrollment/EnrollmentList";
import ParticipantList from "@/components/event/participant/ParticipantList";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList";
import PaymentRecordList from "@/components/PaymentRecordList";
import AdminCouponList from "@/components/acc_booking/AdminCouponList";
import EditBookingModal from "@/components/acc_booking/booking/EditBookingModal";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";
import AdminPointTransactionList from "@/components/acc_booking/AdminPointTransactionList";
import AdminPaymentRecordList from "@/components/payment/AdminPaymentRecordList";

export default {
  name: 'EditMemberModal',
  components: {AdminPaymentRecordList, AdminPointTransactionList, PhotoPreviewInput, EditBookingModal, AdminCouponList, PaymentRecordList, AdminBookingList, ParticipantList, EnrollmentList, BGModal},
  props: {
    shown: Boolean,
    accountId: String,
    hkiaraceCardNo: [String, Number],
    showTab: {
      type: Number,
      default: 0,
    }
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          tabIndex.value = props.showTab;
          getCompanies();
          getUser();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Info
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const user = ref(null);
    const accountPic = ref(null);
    const jwt = ref(null);
    const getUser = function () {
      root.$callAPI('hkiarace/admin/user/', {id: props.accountId, hkiarace_id: props.hkiaraceCardNo}, function (response) {
        user.value = response.body.user;
        accountPic.value = response.body.user.pic;
        jwt.value = response.body.jwt;
      });
    };
    const userEmailVerifiedAtLabel = computed(() => {
      return user.value ? user.value.email_verified_at ? root.$t('my_account.verified_at_template', {date: root.$parseDate(user.value.email_verified_at, 'yyyy-MM-dd')}) : root.$t('not_verified') : null;
    })
    const salutationOptions = ref([
      {value: 'mr', text: root.$t('salutation.mr')},
      {value: 'mrs', text: root.$t('salutation.mrs')},
      {value: 'ms', text: root.$t('salutation.ms')},
      {value: 'dr', text: root.$t('salutation.dr')},
    ]);

    const companies = ref([]);
    const getCompanies = function () {
      root.$callAPI('hkiarace/admin/company/', {
        page_size: -1
      }, function (response) {
        companies.value = response.body.companies;
      });
    };
    const companyOptions = computed(() => {
      return companies.value.map((c) => {
        return {text: c.name, value: c.id};
      })
    });

    const userMembershipValidUntilLabel = computed(() => {
      if (user.value && user.value.id_verified_at) {
        let validUntil = DateTime.fromISO(user.value.id_verified_at).plus({days: 365});

        if (user.value.id_type === 1) {
          let idExpiryDate = DateTime.fromISO(user.value.id_expiry_date);

          if (idExpiryDate < validUntil) {
            validUntil = idExpiryDate;
          }
        }

        return validUntil.toFormat('yyyy-MM-dd');
      }
    })

    const accMembershipValidUntilLabel = computed(() => {
      return user.value.acc_membership_valid_until ? root.$parseDate(user.value.acc_membership_valid_until, 'yyyy-MM-dd') : root.$t('my_account.acc_membership_expired');
    });
    const showAccMembershipValidUntilDatePicker = ref(false);
    const clearAccMembershipValidUntilDate = function () {
      user.value.acc_membership_valid_until = null;
      showAccMembershipValidUntilDatePicker.value = false;
    };

    const accMembershipSuspendUntilLabel = computed(() => {
      return user.value.acc_suspend_until ? root.$parseDate(user.value.acc_suspend_until, 'yyyy-MM-dd') : 'N/A';
    });
    const showAccMembershipSuspendUntilDatePicker = ref(false);
    const clearAccMembershipSuspendUntilDate = function () {
      user.value.acc_suspend_until = null;
      showAccMembershipSuspendUntilDatePicker.value = false;
    };

    const userWelcomeGiftRedeemedLabel = computed(() => {
      return user.value.welcome_gift_redeemed ? user.value.welcome_gift_redeemed_at ? root.$parseDate(user.value.welcome_gift_redeemed_at, 'yyyy-MM-dd') : 'Redeemed at Event' : 'N/A';
    })
    const redeemWelcomeGift = function () {
      if (confirm('Redeem Welcome Gift?')) {
        root.$callAPI('hkiarace/admin/user/redeem_gift/', {
          id: user.value.id,
        }, function (response) {
          root.$showAlertMessage('Gift Redeemed');
          getUser();
        })
      }
    }

    const saveUser = async function () {
      let params = {
        id: user.value.account.id,
        email: user.value.account.email,
        mobile: user.value.mobile,
        salutation: user.value.salutation,
        surname_en: user.value.surname_en,
        given_name_en: user.value.given_name_en,
        surname_zh: user.value.surname_zh,
        given_name_zh: user.value.given_name_zh,
        // company_id: user.value.company.id,
        membership_valid_until: user.value.membership_valid_until,
        octopus_id: user.value.octopus_id,
        acc_membership_valid_until: user.value.acc_membership_valid_until,
        acc_suspend_until: user.value.acc_suspend_until,
        is_trial_user: user.value.is_trial_user,
        remarks: user.value.remarks,

        pic: accountPic.value instanceof File ? await root.$convertFileToBase64(accountPic.value) : accountPic.value,
      };

      root.$callAPI('hkiarace/admin/user/edit/', params, () => {
        root.$showAlertMessage('Info Saved');
        getUser();
      })
    }

    // SASV
    const sasv = computed(() => {
      if (user.value) {
        return user.value.sasv;
      }

      return null
    })
    const sasvStatus = computed(() => {
      if (user.value && user.value.sasv) {
        return root.$t(`sasv_status.${user.value.sasv.status}`);
      }

      return root.$t('sasv_status.NOT_SUBMITTED');
    })
    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    }

    // ID
    const verifyIdStatus = computed(() => {
      if (!user.value) {
        return null;
      }

      if (!user.value.id_no) {
        return root.$t('not_uploaded');
      }

      if (!user.value.id_verified_at) {
        return root.$t('not_verified');
      }

      let verified_at = DateTime.fromISO(user.value.id_verified_at);

      return root.$t('my_account.verified_at_template', {date: verified_at.toFormat('yyyy-MM-dd')});
    })

    // Booking
    const bookingRefreshTrigger = ref(false);
    const editingBookingId = ref(null);
    const editBookingModalShown = ref(false);
    const onBookingEdit = function (item) {
      editingBookingId.value = item.id;
      editBookingModalShown.value = true;
    };
    const onEditBookingModalFinish = function () {
      editBookingModalShown.value = false;
      bookingRefreshTrigger.value = true;
    }

    return {
      dialogShown,
      tabIndex,

      cancel,

      requiredRules,
      user,
      accountPic,
      jwt,
      userEmailVerifiedAtLabel,
      salutationOptions,
      companyOptions,
      userMembershipValidUntilLabel,

      accMembershipValidUntilLabel,
      showAccMembershipValidUntilDatePicker,
      clearAccMembershipValidUntilDate,

      accMembershipSuspendUntilLabel,
      showAccMembershipSuspendUntilDatePicker,
      clearAccMembershipSuspendUntilDate,

      userWelcomeGiftRedeemedLabel,
      redeemWelcomeGift,

      saveUser,

      // SASV
      sasv,
      sasvStatus,
      getURL,

      // ID
      verifyIdStatus,

      // Booking
      bookingRefreshTrigger,
      editingBookingId,
      editBookingModalShown,
      onBookingEdit,
      onEditBookingModalFinish,
    }
  }
}
</script>

<style lang="less">
.edit-member-content {
  display: flex;
  height: 100%;
}
</style>
